function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($attr, $helpers, Object, mainStyles, visibility, wrapperStyles) {
    var h = require("panel").h;
    return {
      value: (h("div", {
        "style": Object.assign({
          /*
           * It's necessary to set the width on the wrapper to be max-width so that
           * the .mp-tooltip-main element has enough width available from the parent
           * to grow up to the max-width.
           */
          'width': $attr(`max-width`) || `auto`,
        }, wrapperStyles),
        "on": {
          click: $helpers.stopPropagation,
          mousedown: $helpers.stopPropagation,
        },
        "class": Object.assign({}, {
          'mp-tooltip-hidden': visibility === 'hidden',
          'mp-tooltip-transitioning': visibility === 'transitioning',
        }, {
          'mp-tooltip-wrapper': true
        }),
      }, (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("div", {
          "style": Object.assign({
            'max-width': $attr(`max-width`),
            /* Use `pre-line` so \n will determine line breaks when no max-width is set */
            'white-space': $attr(`max-width`) ? `pre-line` : `pre`,
            'hyphens': $attr(`max-width`) ? `auto` : `inherit`,
          }, mainStyles),
          "class": Object.assign({}, {
            [`mp-tooltip-placement-${$attr(`placement`)}`]: true,
            [`mp-tooltip-type-${$attr(`type`)}`]: true,
          }, {
            'mp-tooltip-main': true
          }),
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("slot"));;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };
  }.call(this, "$attr" in locals ? locals.$attr : typeof $attr !== "undefined" ? $attr : undefined, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "Object" in locals ? locals.Object : typeof Object !== "undefined" ? Object : undefined, "mainStyles" in locals ? locals.mainStyles : typeof mainStyles !== "undefined" ? mainStyles : undefined, "visibility" in locals ? locals.visibility : typeof visibility !== "undefined" ? visibility : undefined, "wrapperStyles" in locals ? locals.wrapperStyles : typeof wrapperStyles !== "undefined" ? wrapperStyles : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;